// Module
var code = "<ul> <% data.images.forEach(function(image) { %> <li> <a href=\"<%= image.image_url %>\" data-ui=\"thumb\" data-index=\"<%= data.index++ %>\"> <img src=\"<%= image.thumb_url %>\" alt=\"\"> </a> </li> <% }) %> </ul> ";
// Exports
module.exports = code;